import React from 'react'
import loading from "../img/loading.gif";

const Progress_bar = ({bgcolor,progress,height}) => {

    const Parentdiv = {
        height: height,
        width: '100%',
        backgroundColor: 'whitesmoke',
        borderRadius: 40
    }

    const Childdiv = {
        height: '100%',
        width: `${progress}%`,
        backgroundColor: bgcolor,
        borderRadius:40,
        textAlign: 'right'
    }

    const progresstext = {
        padding: 10,
        color: '#fff',
        fontWeight: 900
    }

    return (
        <div style={Parentdiv}>
            <div style={Childdiv}>
                <span style={progresstext}>{`${progress}%`} </span>
            </div>
            <img style={{height:'40px',textAlign:'left'}} src={loading}/>

        </div>
    )
}

export default Progress_bar;
